import { ReactNode } from 'react';

import createCache from '@emotion/cache';
import { CacheProvider, Theme, ThemeProvider } from '@emotion/react';

// Emotion 스타일을 <head> 맨 앞에 주입하여 styled-components보다 낮은 우선순위를 갖도록 설정
const emotionCache = createCache({
  key: 'emotion',
  prepend: true,
});

const UIThemeProvider = ({ theme, children }: { theme: Theme; children: ReactNode }) => {
  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider
        theme={(outerTheme) => ({
          ...outerTheme,
          ...theme,
          // MUI palette와 커스텀 palette(BDSColor) 병합하여 MUI palette.primary/secondary 유지
          palette: { ...outerTheme.palette, ...theme.palette },
        })}
      >
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
};

export default UIThemeProvider;
